"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("./constants");
const palette = {
  action: _constants.colors.action,
  background: _constants.colors.background,
  blue: _constants.colors.blueBackground,
  blueGrey: _constants.colors.blueGreyBackground,
  brown: _constants.colors.brownBackground,
  common: _constants.colors.commonColors,
  default: _constants.colors.defaultColors,
  error: _constants.colors.error,
  green: _constants.colors.greenBackground,
  grey: _constants.colors.oriGrey,
  info: _constants.colors.info,
  inputElements: _constants.colors.inputElements,
  offer: _constants.colors.offer,
  pink: _constants.colors.pinkBackground,
  primary: _constants.colors.primary,
  purple: _constants.colors.purpleBackground,
  red: _constants.colors.redBackground,
  secondary: _constants.colors.secondary,
  success: _constants.colors.success,
  text: _constants.colors.text,
  warning: _constants.colors.warning,
  yellow: _constants.colors.yellowBackground
};
var _default = exports.default = palette;
